import { combineReducers } from 'redux';
import loadingReducer from './loadingReducer';
import metaDataReducer from './metaDataReducer';
import toastReducer from './toastReducer';
import ycrReducer from './admin/ycrReducer';
import countryReducer from './countryReducer';
import ycrAssetReducer from './user/ycrAssetReducer';
import assetValueReducer from './user/assetValueReducer';
import currencyReducer from './currencyReducer';
import assetReducer from './admin/assetReducer';
import adminUserReducer from './admin/userReducer';
import priceReducer from './admin/pricesReducer';
import priceDetailsReducer from './admin/pricesDeatilsReducer';
import assetDetailsValueReducer from './user/assetDetailsValueReducer';
import userReducer from './userReducer';


const rootReducers = combineReducers({
    // Add your reducers here.
    isLoading: loadingReducer,
    isLoading: loadingReducer,
    toast: toastReducer,
    metaData: metaDataReducer,
    countries: countryReducer,
    currencyData: currencyReducer,
    ycrData: ycrReducer,
    ycrAssetData: ycrAssetReducer,
    assetValueData: assetValueReducer,
    assetDetailsValueData: assetDetailsValueReducer,
    assetData: assetReducer,
    user: adminUserReducer,
    prices: priceReducer,
    pricesDetails: priceDetailsReducer,
    user_profile: userReducer,
});


export default rootReducers;